import { render, staticRenderFns } from "./TransactionTypes.vue?vue&type=template&id=83be0ba2&"
import script from "./TransactionTypes.vue?vue&type=script&lang=js&"
export * from "./TransactionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports